import styled from '@emotion/styled';
import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';
import React from 'react';

export const LoadingSpinner = () => {
    return (
        <LoadingSpinnerContainer>
            <ProgressIndicator style="gradient" shape="circular" />
        </LoadingSpinnerContainer>
    );
};

const LoadingSpinnerContainer = styled.div`
    background: rgba(217, 217, 217, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
`;
